import { Component, Input, OnInit } from '@angular/core';

export interface PortfolioHistoricWeightedRows {
  rowData?: PortfolioHistoricWeightedRowsData[];
  averageLifeHeading?: string;
  averageLifeTooltip?: string;
  averageLifeCaveatPlacement?: string;
  averageMaturityHeading?: string;
  averageMaturityTooltip?: string;
  averageMaturityCaveatPlacement?: string;
}

export interface PortfolioHistoricWeightedRowsData {
  asOfDate?: string;
  averageLife?: string;
  averageMaturity?: string;
}

@Component({
  selector: 'ft-historic-weighted-average-table',
  templateUrl: './historic-weighted-average-table.component.html',
  styleUrls: ['./historic-weighted-average-table.component.scss'],
})
export class HistoricWeightedAverageTableComponent {
  @Input() portfolioHistoricWeightedRows: PortfolioHistoricWeightedRows;
}
